import type {
  CreatingApplicationCommand,
  FormEditDraftActionCommand,
} from '@acme/api';

export function commandToEditDraftBody(
  command: Partial<CreatingApplicationCommand> & {
    counterpartyAddress?: string | null;
  }
): FormEditDraftActionCommand {
  const bank = command.bankDetails;
  return {
    comment: '',
    name: command.name ?? null,
    counterparty: command.counterparty ?? null,
    countryId: bank?.destinationCountry,
    amount: command.dealAmount,
    currencyId: command.transferCurrency,
    counterpartyAddress: command.counterpartyAddress ?? null,
    bankName: bank?.bankName ?? null,
    bankAddress: bank?.bankAddress ?? null,
    iban: bank?.iban ?? null,
    swifT_BIC: bank?.swift ?? null,
    subjectTransaction: command.dealSubject ?? null,
    commentsOrFeatures: null,
  };
}
